import { render, staticRenderFns } from "./UserApplications.vue?vue&type=template&id=2ed665a4&scoped=true&"
import script from "./UserApplications.vue?vue&type=script&lang=js&"
export * from "./UserApplications.vue?vue&type=script&lang=js&"
import style0 from "./UserApplications.vue?vue&type=style&index=0&id=2ed665a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed665a4",
  null
  
)

export default component.exports